import { createContext, useContext } from 'react';
import { Event } from '@bizzabo/entities';

export enum View {
    ChannelList,
    Channel,
    Search,
}

export type MessagesContextValues = {
    eventUniqueName: string;
    eventId: number;
    event: Event;
    view: View;
    setView: (view: View) => void;
    setSearchText: (searchText: string) => void;
    searchText: string;
    isEmptyState: boolean;
    setIsEmptyState: (isEmptyState: boolean) => void;
};

export const MessagesContext = createContext<MessagesContextValues | null>(null);

export const useMessages = () => {
    const context = useContext(MessagesContext);
    if (!context) {
        throw new Error('useMessages must be used within a MessagesProvider');
    }
    return context;
};
